import AchievementsProfile from "./components/achievements-profile";
import HeaderProfile from "./components/header-profile";
import StatisticsProfile from "./components/statistics-profile";
import styles from "./profile-tab.module.scss";

export default function ProfileTab(): JSX.Element {
  return (
    <div className={styles.profile_tab}>
      <HeaderProfile />
      <AchievementsProfile />
      <StatisticsProfile />
    </div>
  );
}
